export const deutscheMeisterschaftSiebenerRugbyFinalturnier2026 = {
  "id": "deutsche-meisterschaft-siebener-rugby-finalturnier-2026",
  "title": "Finalturnier der Deutschen Meisterschaft im Siebener Rugby 2026",
  "slug": "deutsche-meisterschaft-siebener-rugby-2026-finalturnier",
  "publishedAt": "2026-02-13T09:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "3 min",
  "tags": [
    "Rugby",
    "Siebener Rugby",
    "Deutsche Meisterschaft",
    "Finalturnier",
    "DIE Finals 2026",
    "Qualifikation"
  ],
  "excerpt": "Am 23. Juli 2026 wird im Rahmen von DIE Finals das Finalturnier der Deutschen Meisterschaft im Siebener Rugby ausgetragen. Bereits fünf Teams sind qualifiziert, vier weitere Plätze werden über Qualifikationsturniere vergeben.",
  "img": "/images/deutsche-meisterschaft-siebener-rugby-2026.jpg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Im Rahmen der Finals 2026 werden am Donnerstag, den 23. Juli 2026, die finalen Wettkämpfe der Deutschen Meisterschaft im Siebener Rugby ausgetragen. Weitere Informationen zu DIE Finals findest du unter https://www.diefinals.de. Das Turnier bildet den sportlichen Höhepunkt der nationalen Siebener Saison und bringt die besten Teams Deutschlands im Kampf um den Meistertitel zusammen."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Bereits qualifizierte Teams"
    },
    {
      "type": "paragraph",
      "content": "Aufgrund ihrer Platzierungen aus dem Vorjahr sind folgende fünf Mannschaften direkt für das Finalturnier qualifiziert:"
    },
    {
      "type": "list",
      "items": [
        "SC Germania List",
        "RG Heidelberg",
        "Hannover 78",
        "Berliner SV",
        "TSV Handschuhsheim"
      ]
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Qualifikationsturniere"
    },
    {
      "type": "paragraph",
      "content": "Die verbleibenden vier Startplätze werden über Qualifikationsturniere vergeben. Diese finden am 27. Juni 2026 statt. Die Anzahl der Turniere sowie die jeweiligen Austragungsorte werden nach Ablauf der Meldefrist auf Grundlage der gemeldeten Teilnehmerzahlen und möglicher Ausrichter festgelegt."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Meldung und Fristen"
    },
    {
      "type": "paragraph",
      "content": "Die offizielle Meldefrist für die Teilnahme an den Qualifikationsturnieren und dem Finalturnier endet am 21. Februar 2026."
    },
    {
      "type": "paragraph",
      "content": "Die Anmeldung erfolgt per E-Mail an:"
    },
    {
      "type": "paragraph",
      "content": "rba-vorsitz@rugbydeutschland.org"
    },
    {
      "type": "paragraph",
      "content": "In der Meldung sind folgende Angaben erforderlich:"
    },
    {
      "type": "list",
      "items": [
        "Teilnahme an den Qualifikationsturnieren",
        "Status der bereits erreichten Qualifikation",
        "Grundsätzliche Bereitschaft zur Ausrichtung eines Qualifikationsturniers"
      ]
    },
    {
      "type": "paragraph",
      "content": "Es sind alle Teams aus Deutschland berechtigt, an den Qualifikationsturnieren teilzunehmen."
    },
    {
      "type": "footer",
      "content": "Deutsche Meisterschaft Siebener Rugby 2026 | Finalturnier im Rahmen von DIE Finals"
    }
  ]
};
